import { useCallback, useEffect, useState } from "react";
import { selectionHistoryApi } from "src/Api/selectionHistory";

export function useUserSelectionHistories(userId: number) {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchList = useCallback(() => {
    if (!userId) return;
    setLoading(true);
    selectionHistoryApi.getUserSelectionHistories(userId)
      .then(res => setList(res.data.data))
      .finally(() => setLoading(false));
  }, [userId]);

  useEffect(() => { fetchList(); }, [fetchList]);

  // POST（保存&リスト取得）
  const storeSelection = useCallback(async (body: any) => {
    await selectionHistoryApi.storeUserSelectionHistory(body);
    fetchList(); // 保存後に最新リスト再取得
  }, [fetchList]);

  return { list, loading, storeSelection, fetchList };
}
